export enum TipoMoedaEnum {

  Real = "Real",
  Ufir = "Ufir"
}
